<template>
  <ul class="timeline">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'timeline',
  props: {}
};
</script>

<style>
  .timeline {
    list-style: none;
    padding: 20px 0 20px;
    position: relative;
    -webkit-animation-duration: 0.5s;
    -moz-animation-duration: 0.5s;
    animation-duration: 0.5s;
  }

  .timeline:before {
    top: 0;
    bottom: 0;
    position: absolute;
    content: " ";
    width: 3px;
    background-color: #eeeeee;
    left: 50%;
    margin-left: -1.5px;
  }

  .timeline .btn-group,
  .timeline .btn-group-vertical {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  @media (max-width: 992px) {
    .timeline:before {
      left: 7%;
    }
  }  
</style>




// WEBPACK FOOTER //
// src/components/UIComponents/Timeline/Timeline.vue